import PlanJsonRightPanel from './PlanJsonRightPanel.component';

export default PlanJsonRightPanel;